import React from 'react';
import { useSearchParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import ExpedientsList from './components/ExpedientsList/ExpedientsList';
import { FolderIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

function ExpedientList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchText = searchParams.get('search') || '';
  const userToken = localStorage.getItem('token');

  const handleSearchChange = value => {
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set('search', value);
    } else {
      newParams.delete('search');
    }
    newParams.delete('page'); // Reset to first page on search
    setSearchParams(newParams);
  };

  if (userToken == null) {
    window.location = '/login';
  }

  return (
    <MainLayout>
      {/* Page header */}
      <div className='sm:flex sm:items-center sm:justify-between mb-8'>
        <div className='mb-4 sm:mb-0'>
          <div className='flex items-center'>
            <div className='mr-4'>
              <FolderIcon className='w-7 h-7 text-blue-600' />
            </div>
            <div>
              <h1 className='text-2xl font-semibold text-slate-900'>Expedientes</h1>
              <p className='mt-1.5 text-sm text-slate-600'>Gestiona todas las reclamaciones y expedientes</p>
            </div>
          </div>
        </div>
      </div>

      {/* Search and Actions */}
      <div className='sm:flex sm:items-center sm:justify-between mb-8'>
        {/* Search Bar */}
        <div className='flex-1 max-w-2xl'>
          <form className='relative'>
            <div className='absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none'>
              <MagnifyingGlassIcon className='h-5 w-5 text-slate-400' />
            </div>
            <input
              id='expedient-search'
              className='block w-full pl-11 pr-4 py-3 text-sm bg-white border border-slate-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-150'
              type='search'
              placeholder='Buscar por deudor, cliente o importe...'
              value={searchText}
              onChange={e => handleSearchChange(e.target.value)}
            />
          </form>
        </div>
      </div>

      {/* Expedients Grid */}
      <div className='bg-white rounded-lg border border-slate-200 overflow-hidden'>
        <div className='grid grid-cols-12 gap-6'>
          <ExpedientsList />
        </div>
      </div>
    </MainLayout>
  );
}

export default ExpedientList;
